import * as React from "react";
const SvgItalic01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 2.965a1.035 1.035 0 0 1 0 2.07h-3.283l-5.224 13.93H14a1.035 1.035 0 0 1 0 2.07H5a1.035 1.035 0 0 1 0-2.07h3.283l5.224-13.93H10a1.035 1.035 0 0 1 0-2.07z"
}));
export default SvgItalic01;
//# sourceMappingURL=Italic01.js.map